<template>
  <v-dialog
    :value="show"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card
      v-if="emergencia"
      class="colorGris"
    >
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="cancelar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>SOLICITUD DE MEDIOS ESTATALES</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            :disabled="!isValid"
            @click="generar"
          >
            Guardar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-toolbar>
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <b>Fecha de petición:</b>
            <v-text-field
              v-model="formulario.fechaPeticion"
              type="date"
              dense
              hide-details
            />
          </v-col>
          <v-col>
            <b>Hora de petición:</b>
            <v-text-field
              v-model="formulario.horaPeticion"
              type="time"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-toolbar>

      <v-form
        ref="form"
        v-model="isValid"
      >
        <v-card-text
          v-if="emergencia"
        >
          <v-row
            class="mt-0"
          >
            <v-col
              cols="6"
            >
              <vx-datos-solicitante
                v-model="formulario.solicitante"
              />

              <vx-localizacion-incendio
                v-model="formulario.localizacion"
                :emergencia="emergencia"
                :fecha-inicio="fechaInicio"
                :hora-inicio="horaInicio"
                class="mt-4"
                @actualizar-coord="tryActualizarHojaCuadricula"
              />

              <vx-caracteristicas-fuego
                v-model="formulario.caracteristicas"
                class="mt-4"
              />

              <v-card
                elevation="2"
                outlined
                class="mt-4"
              >
                <v-toolbar
                  class="primaryLight white--text"
                  dense
                >
                  <div>OBSERVACIONES</div>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-textarea
                        v-model="formulario.observaciones"
                        outlined
                        label="Observaciones"
                        no-resize
                        rows="2"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="6"
            >
              <vx-medios-actuantes
                v-model="formulario.mediosActuantes"
              />
              <vx-medios-solicitados
                v-model="formulario.mediosSolicitados"
                class="mt-4"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
            >
              <vx-informacion-actuacion
                v-model="formulario.actuacion"
                :canales="canales"
                :bases="bases"
                class="mt-4"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { actualizarHojaCuadriculaWMS } from '@/helpers/ArcGIS'

import DatosSolicitante from './DatosSolicitante.vue'
import LocalizacionIncendio from './LocalizacionIncendio.vue'
import CaracteristicasFuego from './CaracteristicasEmergencia.vue'
import MediosActuantes from './MediosActuantes.vue'
import MediosSolicitados from './MediosSolicitados.vue'
import InformacionActuacion from './InformacionActuacion.vue'
import * as MunicipioAPI from '@/helpers/MunicipioAPI'
import * as ArcGIS from '@/helpers/ArcGIS'

export default {
  components: {
    'vx-datos-solicitante': DatosSolicitante,
    'vx-localizacion-incendio': LocalizacionIncendio,
    'vx-caracteristicas-fuego': CaracteristicasFuego,
    'vx-medios-actuantes': MediosActuantes,
    'vx-medios-solicitados': MediosSolicitados,
    'vx-informacion-actuacion': InformacionActuacion
  },
  props: {
    show: Boolean,
    emergencia: Object,
    peticion: Object,
    idIncendio: String
  },
  data: () => ({
    isValid: false,
    canales: [
      { nombre: 'Canal 1', tx: '73,5875', rx: '83,3875' },
      { nombre: 'Canal 2', tx: '73,9875', rx: '83,7875' },
      { nombre: 'Canal 3', tx: '74,000', rx: '83,800' },
      { nombre: 'Canal 4', tx: '75,5875', rx: '85,3875' },
      { nombre: 'Canal 5', tx: '75,600', rx: '85,400' },
      { nombre: 'Canal 6', tx: '75,7875', rx: '85,5875' }
    ],
    bases: [],
    formulario: {
      fechaPeticion: new Date().toISOString().split('T')[0],
      horaPeticion: new Date().toTimeString().split(':').slice(0, 2).join(':'),
      observaciones: '',
      solicitante: {
        organismo: 'CC.AA. NAVARRA',
        personaAutoriza: '',
        cargo: '',
        telefono: '',
        correo: ''
      },
      localizacion: {
        provincia: 'Navarra',
        municipio: '',
        hoja: '',
        cuadricula: '',
        granMagnitud: '',
        situacionDeclarada: ''
      },
      caracteristicas: {
        tamIncendio: '',
        lineasElectricas: '',
        bienes: { poblacion: 0, infraestructuras: 0, espaciosNaturales: 0, bosques: 0 },
        fuego: { pasto: 0, copas: 0, matorral: 0 },
        relieve: { llano: 0, ondulado: 0, quebrado: 0 }
      },
      mediosActuantes: {
        lista1: [
          { nombre: 'CHARLIE-1. Autobomba tipo 1 (≥5.000):', value: undefined, key: 'C1_actuantes' },
          { nombre: 'CHARLIE-2. Autobomba tipo 2 (1.000l – 5.000 l):', value: undefined, key: 'C2_actuantes' },
          { nombre: 'CHARLIE-3. Autobomba tipo 3 (< 1.000 l):', value: undefined, key: 'C3_actuantes' },
          { nombre: 'ROMEO-1. Brigada terrestre tipo 1 (≥12 componentes):', value: undefined, key: 'R1_actuantes' },
          { nombre: 'ROMEO-2. Brigada terrestre tipo 2 (7 a 11 componentes):', value: undefined, key: 'R2_actuantes' },
          { nombre: 'ROMEO-3. Brigada terrestre tipo 3 (≤6 componentes):', value: undefined, key: 'R3_actuantes' },
          { nombre: 'PAPA. Equipo maquinaria pesada:', value: undefined, key: 'P_actuantes' },
          { nombre: 'UNIFORM. Unidad de apoyo en el PMA:', value: undefined, key: 'U_actuantes' }
        ],
        lista2: [
          { nombre: 'BRAVO-1. Brigada helitransportada tipo 1 (≥13 brigadistas):', value: undefined, key: 'B1_actuantes' },
          { nombre: 'BRAVO-2. Brigada helitransportada tipo 2 (8-12 brigadistas):', value: undefined, key: 'B2_actuantes' },
          { nombre: 'BRAVO-3. Brigada helitransportada tipo 3 (≤7 brigadistas):', value: undefined, key: 'B3_actuantes' },
          { nombre: 'KILO. Helicóptero bombardero tipo 1 (>3.000 l):', value: undefined, key: 'K_actuantes' },
          { nombre: 'MIKE. Helicóptero bombardero tipo 2 (entre 1.000 y 3.000 l):', value: undefined, key: 'M_actuantes' },
          { nombre: 'LIMA. Helicóptero bombardero tipo 3 (< 1.000 l):', value: undefined, key: 'L_actuantes' },
          { nombre: 'FOCA. Avión anfibio tipo 1 (> 3.500 l):', value: undefined, key: 'FOCA_actuantes' },
          { nombre: 'ALFA. Avión anfibio tipo 2 (≤ 3.500 l):', value: undefined, key: 'A_actuantes' },
          { nombre: 'TANGO. Avión carga en tierra (≤ 3.500 l):', value: undefined, key: 'T_actuantes' },
          { nombre: 'ACO. Aeronave de coordinación tipo 1 (avión):', value: undefined, key: 'ACO_actuantes' },
          { nombre: 'HOTEL. Aeronave de coordinación tipo 2 (helicóptero):', value: undefined, key: 'H_actuantes' },
          { nombre: 'INDIA. Aeronave civil o militar pilotada por control remoto (RPAS):', value: undefined, key: 'I_actuantes' }
        ]
      },
      mediosSolicitados: {
        tipoMision: '',
        tipoMisionACO: '',
        lista1: [
          { nombre: 'KILO. Helicóptero bombardero tipo 1:', value: undefined, key: 'K_solicitados' },
          { nombre: 'MIKE. Helicóptero bombardero tipo 2:', value: undefined, key: 'M_solicitados' },
          { nombre: 'LIMA. Helicóptero bombardero tipo 3 (< 1.000 l):', value: undefined, key: 'L_solicitados' },
          { nombre: 'BRAVO-1. Brigada helitransportada tipo 1 (BRIF-A):', value: undefined, key: 'B1_solicitados' },
          { nombre: 'BRAVO-2. Brigada helitransportada tipo 2 (BRIF-B, BRIF-i):', value: undefined, key: 'B2_solicitados' },
          { nombre: 'ROMEO-2. Brigada terrestre tipo 2 (BLP):', value: undefined, key: 'R2_solicitados' },
          { nombre: 'ROMEO-3. Brigada terrestre tipo 3 (EPRIF, EPAIF):', value: undefined, key: 'R3_solicitados' }
        ],
        lista2: [
          { nombre: 'FOCA. Avión anfibio tipo 1:', value: undefined, key: 'FOCA_solicitados' },
          { nombre: 'ALFA. Avión anfibio tipo 2:', value: undefined, key: 'A_solicitados' },
          { nombre: 'TANGO. Avión carga en tierra:', value: undefined, key: 'T_solicitados' },
          { nombre: 'ACO. Aeronave de coordinación tipo 1 (ACO):', value: undefined, key: 'ACO_solicitados' },
          { nombre: 'UNIFORM. Unidad de apoyo en el PMA (UMAP):', value: undefined, key: 'U_solicitados' },
          { nombre: 'FAST. Equipo de evaluación y asesoramiento de otras CCAA:', value: undefined, key: 'FAST_solicitados' }
        ]
      },
      actuacion: {
        tipoComunicacion: '',
        dirExtincion: '',
        telefonoDirExtincion: '',
        frecuenciaAM: '',
        idAeronave: '',
        frecuenciaFM: '',
        canal: '',
        rx: '',
        tx: '',
        ptoRepostaje: '',
        yAereo: '',
        xAereo: '',
        ptoEncuentro: '',
        yTerrestre: '',
        xTerrestre: ''
      }
    }
  }),
  computed: {
    ...mapGetters('infraestructura', ['infraestructuras']),

    fechaInicio() {
      const estados = this.emergencia?.ESTADOS
      if (!Array.isArray(estados) || estados.length === 0) return null

      const estadosOrdenados = [...estados].sort((a, b) => {
        const fechaA = this.$date.parseDate(a.FECHA)
        const fechaB = this.$date.parseDate(b.FECHA)
        return fechaA.valueOf() - fechaB.valueOf()
      })

      return this.$date.formatDate(estadosOrdenados[0].FECHA, 'YYYY-MM-DD')
    },
    horaInicio() {
      const estados = this.emergencia?.ESTADOS
      if (!Array.isArray(estados) || estados.length === 0) return null

      const fecha = new Date(estados[0].FECHA)
      return fecha.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false })
    }
  },
  watch: {
    async show(val) {
      if (val) {
        setTimeout(() => { if (this.$refs.form) this.$refs.form.resetValidation() }, 100)
        await this.tryActualizarHojaCuadricula()
        await this.cargarUltimaPeticion()
        const municipio = await MunicipioAPI.getLatLonData(this.emergencia.LONGITUD, this.emergencia.LATITUD)
        this.formulario.localizacion.municipio = municipio.MUNICIPIO

        this.rellenarBases()
      } else {
        Object.assign(this.$data, this.$options.data.apply(this))

        if (this.$refs.form) this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    ...mapActions('incendio', ['peticionMediosGob', 'getPeticionEstatales']),

    async tryActualizarHojaCuadricula() {
      if (!this.emergencia?.LATITUD || !this.emergencia?.LONGITUD) return

      const resultado = await actualizarHojaCuadriculaWMS(
        this.emergencia.LATITUD,
        this.emergencia.LONGITUD
      )

      if (resultado) {
        this.formulario.localizacion.hoja = resultado.hoja || ''
        this.formulario.localizacion.cuadricula = resultado.cuadricula || ''
      }
    },

    rellenarBases() {
      this.bases = this.infraestructuras
        .filter(infra => infra.TIPO === 'Aeropuerto')
        .map(infraestructura => {
          const [lon, lat] = ArcGIS.convertirETRS89ToLatLon(
            Number(infraestructura.X),
            Number(infraestructura.Y)
          )

          return {
            nombre: infraestructura.NOMBRE,
            lon,
            lat
          }
        })
    },

    async cargarUltimaPeticion() {
      try {
        const data = await this.getPeticionEstatales(this.idIncendio)

        // Mapeo Solicitante
        this.formulario.solicitante.organismo = data.Organismo || 'CC.AA. NAVARRA'
        this.formulario.solicitante.personaAutoriza = data.Persona_Autorizada || ''
        this.formulario.solicitante.cargo = data.Cargo_autoriza || ''
        this.formulario.solicitante.telefono = data.Telefono_solicitante || ''
        this.formulario.solicitante.correo = data.Correo_solicitante || ''

        // Mapeo Localizacion
        this.formulario.localizacion.provincia = data.Provincia_incendio || 'Navarra'
        this.formulario.localizacion.hoja = data.Hoja_incendio || ''
        this.formulario.localizacion.cuadricula = data.Cuadricula_incendio || ''
        this.formulario.localizacion.granMagnitud = data.IncendiosGranMagnitudAct || ''
        this.formulario.localizacion.situacionDeclarada = data.SituacionOperativaDeclarada || ''

        // Mapeo Características
        this.formulario.observaciones = data.observaciones || ''
        this.formulario.caracteristicas.tamIncendio = data.Tamaño_incendio || ''
        this.formulario.caracteristicas.lineasElectricas = data.lineasElectricas || ''
        this.formulario.caracteristicas.bienes.poblacion = Number(data.Poblaciones) || 0
        this.formulario.caracteristicas.bienes.infraestructuras = Number(data.Infraestructuras) || 0
        this.formulario.caracteristicas.bienes.espaciosNaturales = Number(data.ENP) || 0
        this.formulario.caracteristicas.bienes.bosques = Number(data.Bosques) || 0
        this.formulario.caracteristicas.fuego.pasto = Number(data.Pastos) || 0
        this.formulario.caracteristicas.fuego.copas = Number(data.Copas) || 0
        this.formulario.caracteristicas.fuego.matorral = Number(data.Matorral) || 0
        this.formulario.caracteristicas.relieve.llano = Number(data.Relieve_llano) || 0
        this.formulario.caracteristicas.relieve.ondulado = Number(data.Relieve_Ondulado) || 0
        this.formulario.caracteristicas.relieve.quebrado = Number(data.Relieve_Quebrado) || 0;

        // Mapeo Medios Actuantes y Solicitados usando las keys configuradas en el Data
        [...this.formulario.mediosActuantes.lista1, ...this.formulario.mediosActuantes.lista2].forEach(m => {
          m.value = data[m.key] ?? 0
        });

        [...this.formulario.mediosSolicitados.lista1, ...this.formulario.mediosSolicitados.lista2].forEach(m => {
          m.value = data[m.key] ?? 0
        })

        // Mapeo Información de actuación
        this.formulario.mediosSolicitados.tipoMision = data.MovilizacionBLP || ''
        this.formulario.mediosSolicitados.tipoMisionACO = data.ACOMision || ''
        this.formulario.actuacion.tipoComunicacion = data.TipoComunicacionesTerrestres || ''
        this.formulario.actuacion.dirExtincion = data.Director_extincion || ''
        this.formulario.actuacion.telefonoDirExtincion = data.Telefonomovil_DE || ''
        this.formulario.actuacion.frecuenciaAM = data.Frecuencia_AM || ''
        this.formulario.actuacion.idAeronave = data.Id_ACO || ''
        this.formulario.actuacion.frecuenciaFM = data.Frecuencia_FM || ''
        this.formulario.actuacion.canal = data.Canal || ''
        this.formulario.actuacion.rx = data.Rx || ''
        this.formulario.actuacion.tx = data.Tx || ''
        this.formulario.actuacion.ptoRepostaje = data.Punto_repostaje || ''
        this.formulario.actuacion.ptoEncuentro = data.Punto_encuentro || ''
        this.formulario.actuacion.yAereo = data.Lati_Punt_Respos || ''
        this.formulario.actuacion.xAereo = data.Long_Punto_Repos || ''
        this.formulario.actuacion.yTerrestre = data.Lati_Punt_Enc || ''
        this.formulario.actuacion.xTerrestre = data.Long_Punt_Enc || ''
      } catch {
        this.$notify({
          title: 'Sin solicitudes previas',
          text: 'No se ha encontrado ninguna solicitud anterior para este incendio.',
          type: 'warning'
        })
      }
    },

    async generar() {
      if (!this.isValid || !this.$refs.form.validate()) return

      const peticion = {
        idIncendio: this.idIncendio,
        Fecha_actual: this.formulario.fechaPeticion,
        Hora_actual: this.formulario.horaPeticion,
        Organismo: this.formulario.solicitante.organismo,
        Persona_Autorizada: this.formulario.solicitante.personaAutoriza ?? '',
        Cargo_autoriza: this.formulario.solicitante.cargo ?? '',
        Telefono_solicitante: this.formulario.solicitante.telefono.replace(/\D/g, '').slice(0, 9),
        Correo_solicitante: this.formulario.solicitante.correo,

        Provincia_incendio: this.formulario.localizacion.provincia,
        Municipio_incendio: this.formulario.localizacion.municipio,
        Hoja_incendio: this.formulario.localizacion.hoja,
        Cuadricula_incendio: this.formulario.localizacion.cuadricula,
        IncendiosGranMagnitudAct: this.formulario.localizacion.granMagnitud,
        SituacionOperativaDeclarada: this.formulario.localizacion.situacionDeclarada,
        Latitud_Orig_Inc: this.emergencia.LATITUD,
        Long_Orig_Inc: this.emergencia.LONGITUD,
        Fecha_incendio: this.fechaInicio,
        Hora_deteccion: this.horaInicio,

        Tamaño_incendio: this.formulario.caracteristicas.tamIncendio,
        lineasElectricas: this.formulario.caracteristicas.lineasElectricas,
        Poblaciones: this.formulario.caracteristicas.bienes.poblacion,
        Infraestructuras: this.formulario.caracteristicas.bienes.infraestructuras,
        ENP: this.formulario.caracteristicas.bienes.espaciosNaturales,
        Bosques: this.formulario.caracteristicas.bienes.bosques,
        Pastos: this.formulario.caracteristicas.fuego.pasto,
        Copas: this.formulario.caracteristicas.fuego.copas,
        Matorral: this.formulario.caracteristicas.fuego.matorral,
        Relieve_llano: this.formulario.caracteristicas.relieve.llano,
        Relieve_Ondulado: this.formulario.caracteristicas.relieve.ondulado,
        Relieve_Quebrado: this.formulario.caracteristicas.relieve.quebrado,

        MovilizacionBLP: this.formulario.mediosSolicitados.tipoMision ?? '',
        ACOMision: this.formulario.mediosSolicitados.tipoMisionACO ?? '',
        TipoComunicacionesTerrestres: this.formulario.actuacion.tipoComunicacion ?? '',
        Director_extincion: this.formulario.actuacion.dirExtincion,
        Telefonomovil_DE: this.formulario.actuacion.telefonoDirExtincion,
        Frecuencia_AM: this.formulario.actuacion.frecuenciaAM,
        Id_ACO: this.formulario.actuacion.idAeronave,
        Frecuencia_FM: this.formulario.actuacion.frecuenciaFM,
        Canal: this.formulario.actuacion.canal,
        Rx: this.formulario.actuacion.rx,
        Tx: this.formulario.actuacion.tx,

        Punto_repostaje: this.formulario.actuacion.ptoRepostaje,
        Lati_Punt_Respos: this.formulario.actuacion.yAereo,
        Long_Punto_Repos: this.formulario.actuacion.xAereo,
        Punto_encuentro: this.formulario.actuacion.ptoEncuentro,
        Lati_Punt_Enc: this.formulario.actuacion.yTerrestre,
        Long_Punt_Enc: this.formulario.actuacion.xTerrestre,
        observaciones: this.formulario.observaciones ?? ''
      };

      // Mapeo automático de los medios por su Key
      [...this.formulario.mediosActuantes.lista1, ...this.formulario.mediosActuantes.lista2].forEach(m => {
        peticion[m.key] = m.value ?? ''
      });
      [...this.formulario.mediosSolicitados.lista1, ...this.formulario.mediosSolicitados.lista2].forEach(m => {
        peticion[m.key] = m.value ?? ''
      })

      await this.peticionMediosGob(peticion)
    },

    cancelar() {
      this.$emit('cancelar')
    }
  }
}
</script>

<style lang="scss" scoped>
  .colorGris {
    background-color: #F9F9F9;
  }
</style>
